export interface Product {
  id: string;
  name: string;
  category: 'sicak' | 'soguk' | 'chiller' | 'yiyecek' | 'sezonluk';
  price: number;
  calories: number;
  description: string;
  image: string;
  alt: string;
  tags: string[];
  popular?: boolean;
  seasonal?: boolean;
}

export const products: Product[] = [
{
  id: 'prod-001',
  name: 'Caramel Latte',
  category: 'sicak',
  price: 89,
  calories: 240,
  description: 'Espresso, buharda ısıtılmış süt ve karamel şurubu',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_172246bee-1778455449428.png",
  alt: 'Caramel Latte — karamel soslu sütlü espresso fincanı',
  tags: ['sütlü'],
  popular: true
},
{
  id: 'prod-002',
  name: 'Hazelnut Latte',
  category: 'sicak',
  price: 87,
  calories: 230,
  description: 'Espresso, süt ve fındık şurubu ile hazırlanan imza latte',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_130caa1dd-1768341207250.png",
  alt: 'Hazelnut Latte — fındık aromalı sütlü kahve fincanı',
  tags: ['sütlü'],
  popular: true
},
{
  id: 'prod-003',
  name: 'Americano',
  category: 'sicak',
  price: 72,
  calories: 15,
  description: 'Çift espresso ve sıcak su',
  image: "https://images.unsplash.com/photo-1542837506-2ecd71272ccf",
  alt: 'Americano — siyah espresso kahve küçük bardakta',
  tags: ['vegan', 'sütsüz']
},
{
  id: 'prod-004',
  name: 'Cappuccino',
  category: 'sicak',
  price: 80,
  calories: 140,
  description: 'Eşit miktarda espresso, buhar ve köpük',
  image: "https://images.unsplash.com/photo-1484710343284-134eb85bc19a",
  alt: 'Cappuccino — köpüklü sütlü espresso fincanı',
  tags: ['sütlü']
},
{
  id: 'prod-005',
  name: 'Vanilla Latte',
  category: 'sicak',
  price: 85,
  calories: 220,
  description: 'Espresso, buharda ısıtılmış süt ve vanilya şurubu',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18d603149-1784301376042.png",
  alt: 'Vanilla Latte — vanilyalı sütlü espresso fincanı',
  tags: ['sütlü', 'vegan uyumlu'],
  popular: true
},
{
  id: 'prod-006',
  name: 'Mocha',
  category: 'sicak',
  price: 88,
  calories: 290,
  description: 'Espresso, çikolata şurubu ve buharda ısıtılmış süt',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fc01bc29-1767830235661.png",
  alt: 'Mocha — çikolata aromalı sütlü espresso',
  tags: ['sütlü']
},
{
  id: 'prod-007',
  name: 'Caramel Chiller',
  category: 'chiller',
  price: 99,
  calories: 420,
  description: 'Gloria Jean\'s imza içeceği — dondurulmuş kahve ve karamel',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_148018cc6-1784301377839.png",
  alt: 'Caramel Chiller — Gloria Jean\'s imza soğuk blended kahve',
  tags: ['sütlü'],
  popular: true
},
{
  id: 'prod-008',
  name: 'Hazelnut Chiller',
  category: 'chiller',
  price: 99,
  calories: 410,
  description: 'Fındık aromalı dondurulmuş kahve ve krem şanti',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_152be109d-1784112595682.png",
  alt: 'Hazelnut Chiller — fındık aromalı blended soğuk kahve',
  tags: ['sütlü'],
  popular: true
},
{
  id: 'prod-009',
  name: 'Mocha Chiller',
  category: 'chiller',
  price: 99,
  calories: 450,
  description: 'Çikolata, kahve, buz ve krem şanti',
  image: "https://images.unsplash.com/photo-1723797533688-e5c4ac87e73a",
  alt: 'Mocha Chiller — çikolata kahve blended içecek',
  tags: ['sütlü']
},
{
  id: 'prod-010',
  name: 'Iced Caramel Latte',
  category: 'soguk',
  price: 88,
  calories: 230,
  description: 'Soğuk espresso, süt ve karamel şurubu',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_16155dd2b-1772211374360.png",
  alt: 'Iced Caramel Latte — buzlu karamel sütlü espresso',
  tags: ['sütlü']
},
{
  id: 'prod-011',
  name: 'Cold Brew',
  category: 'soguk',
  price: 79,
  calories: 5,
  description: '20 saat soğuk demleme, yumuşak ve yoğun',
  image: "https://images.unsplash.com/photo-1684229835147-4e51c738fc88",
  alt: 'Cold Brew — soğuk demleme kahve buz dolu bardakta',
  tags: ['vegan', 'sütsüz'],
  popular: true
},
{
  id: 'prod-012',
  name: 'Sezonluk Baharatlı Latte',
  category: 'sezonluk',
  price: 95,
  calories: 360,
  description: 'Tarçın ve baharat aromalı sezonluk özel latte',
  image: "https://images.unsplash.com/photo-1633607957150-de1ce7e95c64",
  alt: 'Sezonluk Baharatlı Latte — tarçın aromalı sıcak kahve',
  tags: ['sütlü', 'sezonluk'],
  seasonal: true,
  popular: true
},
{
  id: 'prod-013',
  name: 'Tereyağlı Kruvasan',
  category: 'yiyecek',
  price: 45,
  calories: 310,
  description: 'Taze pişmiş çıtır kruvasan',
  image: "https://images.unsplash.com/photo-1657782765569-2368635340dd",
  alt: 'Tereyağlı Kruvasan — altın rengi çıtır kruvasan',
  tags: ['vejetaryen'],
  popular: true
},
{
  id: 'prod-014',
  name: 'Cheesecake Dilimi',
  category: 'yiyecek',
  price: 65,
  calories: 460,
  description: 'Klasik New York tarzı cheesecake',
  image: "https://images.unsplash.com/photo-1727491922007-85f381c11c86",
  alt: 'Cheesecake dilimi — kremsi beyaz cheesecake pasta',
  tags: ['vejetaryen']
},
{
  id: 'prod-015',
  name: 'Çikolatalı Muffin',
  category: 'yiyecek',
  price: 55,
  calories: 390,
  description: 'Taze pişmiş çikolata parçalı muffin',
  image: "https://images.unsplash.com/photo-1731698977274-cd63bdcbe6e4",
  alt: 'Çikolatalı Muffin — çikolata parçalı taze pişmiş kek',
  tags: ['vejetaryen']
},
{
  id: 'prod-016',
  name: 'Avokadolu Sandviç',
  category: 'yiyecek',
  price: 75,
  calories: 340,
  description: 'Taze avokado, domates ve roka ile tam tahıllı ekmek',
  image: "https://images.unsplash.com/photo-1729889965980-6805d097d266",
  alt: 'Avokadolu Sandviç — tam tahıllı ekmekte taze avokado',
  tags: ['vegan', 'sağlıklı']
}];


export type CartItem = {
  cartId: string;
  product: Product;
  quantity: number;
  size: 'Tall' | 'Grande' | 'Venti';
  milk: string;
  syrup: string;
  extraShot: boolean;
};

export const categories = [
{ id: 'all', label: 'Tümü' },
{ id: 'sezonluk', label: 'Sezonluk' },
{ id: 'sicak', label: 'Sıcak' },
{ id: 'soguk', label: 'Soğuk' },
{ id: 'chiller', label: 'Chiller' },
{ id: 'yiyecek', label: 'Yiyecek' }] as
const;

export const milkOptions = ['Tam Yağlı Süt', 'Yağsız Süt', 'Yulaf Sütü', 'Badem Sütü', 'Soya Sütü', 'Sütsüz'];
export const syrupOptions = ['Yok', 'Vanilya', 'Karamel', 'Fındık', 'Çikolata', 'Nane'];
export const sizes: Array<'Tall' | 'Grande' | 'Venti'> = ['Tall', 'Grande', 'Venti'];
export const sizePriceAdder: Record<string, number> = { Tall: 0, Grande: 8, Venti: 16 };